import Metaphysics from './Metaphysics'

export default Metaphysics
// eslint-disable-next-line import/export
export * from './Metaphysics'
